import Text from '@helvetia/components/Text'
import * as H from 'history'
import * as React from 'react'
import { withNamespaces, WithNamespaces } from 'react-i18next'

interface Props {
  history: H.History
}

const HeaderTitle: React.SFC<WithNamespaces & Props> = ({ history, t }) => {
  if (history.location.pathname.includes('/portal'))
    return <Text as="div" size="sBold">{`${t('header.title')} - Portal`}</Text>
  return (
    <Text as="div" size="sBold">
      {t('header.title')}
    </Text>
  )
}

export default withNamespaces()(HeaderTitle)
